/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import TextAtomic from '../../atomic/Text'
import styles from './Text.module.css'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Text = ({ text, color, ...props }: any) => {
  return (
    <TextAtomic
      text={text}
      className={styles.text}
      style={{ color: color ? `var(${color})` : '#616161' }}
      {...props}
    />
  )
}

export default Text
